export default __webpack_public_path__ + "static/media/partners-logo-hanyang-w@3x.25b0b6d5.webp";